export const AttributionReportFormats = {
  HTML: 'HTML',
  MD: 'MD',
  PDF: 'PDF',
  CSV: 'CSV',
  TXT: 'TXT',
  SPDX: 'SPDX',
  SPDX_JSON: 'SPDX_JSON',
  CYCLONEDX_JSON: 'CYCLONEDX_JSON',
  CYCLONEDX_XML: 'CYCLONEDX_XML',
} as const;

export type ReportFormat = typeof AttributionReportFormats[keyof typeof AttributionReportFormats];

export const isReportFormat = (format: string): format is ReportFormat =>
  Object.values(AttributionReportFormats).includes(format as ReportFormat);

export const DependencyInfoOptions = {
  Project: 'Project',
  Library: 'Package',
  Authors: 'Authors',
  Description: 'Description',
  ConcludedLicense: 'Concluded License',
  License: 'Declared License',
  CustomTextLicense: 'License Header',
  FullTextLicense: 'Full License Text',
  OtherLicenses: 'Discovered License(s)',
  FilePath: 'File Path',
  Source: 'Package Manager',
  ProjectUrl: 'Package Homepage',
  PackageDownloadUrl: 'Package Download URL',
  DependencyPaths: 'Dependency Paths',
  IssueNotes: 'Issue Resolution Notes',
  Copyrights: 'Copyrights',
  NoticeFiles: 'Notice Files',
  LicenseFileURL: 'License URL',
} as const;

export const allDependencyInfoOptions = Object.keys(DependencyInfoOptions);

/*
 * !!!!!!!!!!
 * If you add a new option here, you must also add it to the full report options
 * in `shared/reports/utils.ts`!
 * !!!!!!!!!!
 */
export type AttributionReportIncludeOptions = {
  // CycloneDX only
  includeClosedVulnerabilities?: boolean;
  includeCopyrightList?: boolean;
  includeDeepDependencies?: boolean;
  includeSnippetDependencies?: boolean;
  // All but CSV
  includeDependencySummary?: boolean;
  includeDirectDependencies?: boolean;
  // CSV, TXT, SPDX, SPDX_JSON
  includeFileMatches?: boolean;
  // TXT, HTML, CSV, MD, PDF
  includeHashAndVersionData?: boolean;
  // TXT only
  includeLicenseHeaders?: boolean;
  // All but CSV
  includeLicenseList?: boolean;
  includeLicenseScan?: boolean;
  // All but CSV
  includeNonLicenseCopyrights?: boolean;
  // TXT, HTML, MD, PDF, SPDX
  includeNoticeFiles?: boolean;
  // CycloneDX only
  includeOpenVulnerabilities?: boolean;
  includePackageLabels?: boolean;
  includeProjectLicense?: boolean;
  // CycloneDX only
  includeSupportStatus?: boolean;
  // TXT, HTML, MD, PDF
  includeConcludedLicenses?: boolean;
}
